import { dateConstant } from '../constant';
export const dateAction = {
    updateMessageDatePersist,
    updateClearDate,
};

function updateMessageDatePersist(date) {
    return (dispatch) => {
        dispatch({ type: dateConstant.UPDATE_MESSAGE_DATE_PERSIST, payload: { date } });
    };
}

function updateClearDate() {
    let date = null;
    return (dispatch) => {
        dispatch({ type: dateConstant.UPDATE_CLEAR_DATE, payload: { date } });
    };
}
